module.exports = __webpack_public_path__ + "img/1567400665.a0d7c0ec.jpg";